export default {
  name: 'close',
  components: {},
  props: [],
  data () {
    return {
      errors: [],
      btn_submit: false,
      checklist: {},
      closing_date: ''
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    show (checklist) {
      this.checklist = checklist
      this.$refs.closeModal.show()
    },
    hide () {
      this.$refs.closeModal.hide()
    },
    close () {
      this.$loading.start()
      this.btn_submit = true
      this.$store.dispatch('Checklist/closeChecklist', {checklist: this.checklist, closing_date: this.$moment(this.closing_date).format('YYYY-MM-DD')}).then(res => {
        this.$emit('closeSuccess', res)
        // checklist.status = res.status
        this.btn_submit = false
        this.$loading.complete()
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
        this.btn_submit = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/list/close/close.js